import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentIcon from '~ui/components/icon/icon.vue'
import UiComponentImage from '~ui/components/image/image.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentWrapper, { class: 'security' }, () => [
    h(UiComponentContainer, { class: 'inner' }, () => [
      h(UiComponentImage, {
        key: `security-desktop-${props.securitySectionHeight}-${props.securitySectionWidth}`,
        alt: props.componentSecurity.backgroundDesktop.alt,
        class: 'background desktop',
        expectedSize: props.securitySectionWidth,
        extraParams: {
          h: props.securitySectionHeight,
          w: props.securitySectionWidth,
          fit: 'crop',
        },
        height: props.componentSecurity.backgroundDesktop.height,
        source: props.componentSecurity.backgroundDesktop.url,
        width: props.componentSecurity.backgroundDesktop.width,
      }),
      h(UiComponentImage, {
        key: `security-mobile-${props.securitySectionHeight}-${props.securitySectionWidth}`,
        alt: props.componentSecurity.backgroundMobile.alt,
        class: 'background mobile',
        expectedSize: props.securitySectionWidth,
        extraParams: {
          h: props.securitySectionHeight,
          w: props.securitySectionWidth,
          fit: 'crop',
        },
        height: props.componentSecurity.backgroundMobile.height,
        orientation: 'portrait',
        source: props.componentSecurity.backgroundMobile.url,
        width: props.componentSecurity.backgroundMobile.width,
      }),
      h(UiComponentImage, {
        key: `badge-${props.securityIconSize}`,
        alt: props.componentSecurity.icon.alt,
        class: 'badge',
        expectedSize: props.securityIconSize,
        height: props.componentSecurity.icon.height,
        orientation: 'portrait',
        source: props.componentSecurity.icon.url,
        width: props.componentSecurity.icon.width,
      }),
      h(UiComponentHeading, { as: 'paragraph', level: 3 }, () => [
        props.record.title || props.componentSecurity.title,
      ]),
      h(UiComponentParagraph, {}, () => [props.record.text || props.componentSecurity.text]),
      h(
        AtomButton,
        {
          action: 'Button clicked',
          attributes: {
            action: 'https://security.livestorm.co/',
          },
          label: 'Security section CTA',
          size: 'l',
          to: 'https://security.livestorm.co/',
        },
        () => [
          props.global.learnMore,
          h(UiComponentIcon, { type: 'arrow-right' }),
        ],
      ),
    ]),
  ])
}

Functional.props = {
  componentSecurity: {
    required: true,
    type: Object,
  },
  global: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  securityIconSize: {
    required: true,
    type: Number,
  },
  securitySectionHeight: {
    required: true,
    type: Number,
  },
  securitySectionWidth: {
    required: true,
    type: Number,
  },
}

export default Functional
